import React, { useState, useEffect } from 'react';
import { Card, Col, Nav, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import Avatar from "../../components/Avatar";
import UsersKPI from '../../components/UsersKPI';
import OrdersKPI from '../../components/OrdersKPI';
import CouponsKPI from '../../components/CouponsKPI';
import ProductsKPI from '../../components/ProductsKPI';
import RevenueKPI from '../../components/RevenueKPI';
import axiosInstance from '../../api/axios';import OutletRevenueKpi from '../../components/OutletRevenueKpi';
import AllTimeKPI from '../../components/AllTimeKPI';
import SmartInsightsList from '../../components/Smart-Insights/SmartInsightsList';

const Dashboard = () => {
  const [outlets, setOutlets] = useState([]);
  const [outletFilter, setOutletFilter] = useState('all');
  const [loadingOutlets, setLoadingOutlets] = useState(false);
  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  useEffect(() => {
    getOutlets();
  }, []);

  const getOutlets = async () => {
    try {
      setLoadingOutlets(true);
      const token = localStorage.getItem('authToken');
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axiosInstance.get('outlet', { headers });
      if (response?.data?.status === true) {
        const filteredOutlets = response?.data?.data?.outlets?.filter(out => out?.status === 'ACTIVE');
        // setOutlets(response?.data?.data?.outlets);
        setOutlets(filteredOutlets);
      }
    } catch (error) {
      console.error('Error fetching outlets:', error);
    } finally {
      setLoadingOutlets(false);
    }
  };

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <OutletRevenueKpi 
          outletFilter={outletFilter}
          loadingOutlets={loadingOutlets}
        />
{/* 
        <div className='mt-4'>
          <UsersKPI 
            outlets={outlets} 
            loadingOutlets={loadingOutlets} 
            outletFilter={outletFilter} 
          />
        </div> */}

        {/* <div className='mt-4'>
          <CouponsKPI 
            outlets={outlets} 
            loadingOutlets={loadingOutlets} 
            outletFilter={outletFilter} 
          />
        </div> */}

        {/* OMIT JI  */}
        {/* <SmartInsightsList /> */}

        <div className='mt-4'>
          <AllTimeKPI 
            outlets={outlets} 
            setOutletFilter={setOutletFilter} 
            loadingOutlets={loadingOutlets} 
            outletFilter={outletFilter} 
          />
        </div>
        
        {/* <div className='mt-4'>
          <OrdersKPI 
            outlets={outlets} 
            setOutletFilter={setOutletFilter} 
            loadingOutlets={loadingOutlets} 
            outletFilter={outletFilter} 
          />
        </div> */}
        
        {/* <div className='mt-4'>
          <RevenueKPI 
            outlets={outlets} 
            loadingOutlets={loadingOutlets} 
            outletFilter={outletFilter} 
          />
        </div> */}
        
        <div className='mt-4'>
          <ProductsKPI 
            outlets={outlets} 
            loadingOutlets={loadingOutlets} 
            outletFilter={outletFilter} 
          />
        </div>
        
        <div className='mt-4'>
          <Footer />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;

// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';
// import { Spinner, Form, Button, Modal, Badge, Pagination } from 'react-bootstrap';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import axios from '../api/axios';
// import Header from '../layouts/Header';
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     BarController,
//     PointElement,
//     LineElement,
//     LineController,
//     ArcElement,
//     DoughnutController,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import { Chart, Doughnut } from 'react-chartjs-2';

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     BarController,
//     PointElement,
//     LineElement,
//     LineController,
//     ArcElement,
//     DoughnutController,
//     Tooltip,
//     Legend
// );

// /* ─── Formatters ─── */
// const fmt = (val, dec = 2) =>
//     `₹${Number(val || 0).toLocaleString('en-IN', { minimumFractionDigits: dec, maximumFractionDigits: dec })}`;
// const fmtNum = (val) => Number(val || 0).toLocaleString('en-IN');
// const fmtTime = (iso) => {
//     if (!iso) return '—';
//     return new Date(iso).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });
// };
// const fmtDateLabel = (df, cr) => {
//     if (df === 'custom' && cr) return `${cr.start} → ${cr.end}`;
//     return { today: 'Today', yesterday: 'Yesterday', last7days: 'Last 7 Days', last30days: 'Last 30 Days', thisMonth: 'This Month', lastMonth: 'Last Month' }[df] || df;
// };
// const fmtViewDate = (d) =>
//     new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
// const fmtViewTime = (d) =>
//     new Date(d).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });

// /* ─── Date filter → { startDate, endDate } strings ─── */
// const resolveDateRange = (dateFilter, appliedCustomRange) => {
//     const pad = (n) => String(n).padStart(2, '0');
//     const toStr = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     switch (dateFilter) {
//         case 'today': {
//             const s = toStr(today);
//             return { startDate: s, endDate: s };
//         }
//         case 'yesterday': {
//             const y = new Date(today);
//             y.setDate(y.getDate() - 1);
//             const s = toStr(y);
//             return { startDate: s, endDate: s };
//         }
//         case 'last7days': {
//             const s = new Date(today);
//             s.setDate(s.getDate() - 6);
//             return { startDate: toStr(s), endDate: toStr(today) };
//         }
//         case 'last30days': {
//             const s = new Date(today);
//             s.setDate(s.getDate() - 29);
//             return { startDate: toStr(s), endDate: toStr(today) };
//         }
//         case 'thisMonth': {
//             const s = new Date(today.getFullYear(), today.getMonth(), 1);
//             return { startDate: toStr(s), endDate: toStr(today) };
//         }
//         case 'lastMonth': {
//             const s = new Date(today.getFullYear(), today.getMonth() - 1, 1);
//             const e = new Date(today.getFullYear(), today.getMonth(), 0);
//             return { startDate: toStr(s), endDate: toStr(e) };
//         }
//         case 'custom': {
//             if (appliedCustomRange) {
//                 return { startDate: appliedCustomRange.start, endDate: appliedCustomRange.end };
//             }
//             const s = toStr(today);
//             return { startDate: s, endDate: s };
//         }
//         default: {
//             const s = toStr(today);
//             return { startDate: s, endDate: s };
//         }
//     }
// };

// /* ─── Modal filter configs ─── */
// const MODAL_CONFIGS = {
//     total: { title: 'Total Orders', badge: 'primary', statusFilter: '', typeFilter: '' },
//     cancelled: { title: 'Cancelled Orders', badge: 'danger', statusFilter: 'CANCELLED', typeFilter: '' },
//     delayed: { title: 'Delayed Orders', badge: 'warning', statusFilter: '', typeFilter: '' },
//     early: { title: 'Early Orders', badge: 'success', statusFilter: '', typeFilter: '' },
//     complimentary: { title: 'Complimentary Orders', badge: 'secondary', statusFilter: '', typeFilter: 'COMPLIMENTARY' },
// };

// const DATE_FILTER_OPTIONS = [
//     { label: 'Today', value: 'today' },
//     { label: 'Yesterday', value: 'yesterday' },
//     { label: 'Last 7 Days', value: 'last7days' },
//     { label: 'Last 30 Days', value: 'last30days' },
//     { label: 'This Month', value: 'thisMonth' },
//     { label: 'Last Month', value: 'lastMonth' },
//     { label: 'Custom Range', value: 'custom' },
// ];

// const getDefaultStartDate = () => {
//     const d = new Date();
//     d.setDate(d.getDate() - 91);
//     return d;
// };

// /* ─── Sub-components ─── */
// const Card = ({ title, icon, children, style = {}, id }) => (
//     <div id={id} style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'visible', ...style }}>
//         {title && (
//             <div style={{ padding: '9px 14px', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', gap: 7, background: '#fafafa' }}>
//                 <i className={`bi ${icon}`} style={{ fontSize: 11, color: '#4d8af0' }} />
//                 <span style={{ fontSize: 10, fontWeight: 800, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.7px' }}>{title}</span>
//             </div>
//         )}
//         <div style={{ padding: '11px 13px' }}>{children}</div>
//     </div>
// );

// const RankRow = ({ rank, name, qty, isTop }) => (
//     <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 8px', borderRadius: 7, marginBottom: 3, background: rank === 1 ? (isTop ? '#f0fdf4' : '#fff5f5') : 'transparent' }}>
//         <div style={{ width: 18, height: 18, borderRadius: '50%', fontSize: 9, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, background: rank === 1 ? (isTop ? '#22c55e' : '#ef4444') : '#e5e7eb', color: rank === 1 ? '#fff' : '#9ca3af' }}>{rank}</div>
//         <span style={{ flex: 1, fontSize: 11, color: '#374151', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
//             {!name || name === 'N/A' ? <span style={{ color: '#d1d5db' }}>—</span> : name}
//         </span>
//         <span style={{ fontSize: 10, fontWeight: 700, padding: '1px 7px', borderRadius: 99, flexShrink: 0, color: isTop ? '#16a34a' : '#dc2626', background: isTop ? '#dcfce7' : '#fee2e2' }}>{qty}</span>
//     </div>
// );

// const CouponRow = ({ coupon, used, discount }) => (
//     <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0', borderBottom: '1px solid #f9fafb' }}>
//         <i className="bi bi-tag-fill" style={{ fontSize: 10, color: '#8b5cf6', marginRight: 7, flexShrink: 0 }} />
//         <span style={{ flex: 1, fontSize: 11, fontWeight: 700, color: '#374151', fontFamily: 'monospace' }}>{coupon}</span>
//         <span style={{ fontSize: 10, color: '#6b7280', marginRight: 10 }}>{used}x used</span>
//         <span style={{ fontSize: 11, fontWeight: 700, color: '#dc2626' }}>-{fmt(discount)}</span>
//     </div>
// );

// /* ─── Donut ring (pure SVG, no chart lib needed for a single static ring) ─── */
// const DonutRing = ({ pct, color, size = 78, stroke = 9 }) => {
//     const r = (size - stroke) / 2;
//     const c = size / 2;
//     const circumference = 2 * Math.PI * r;
//     const clamped = Math.max(0, Math.min(100, pct));
//     const offset = circumference - (clamped / 100) * circumference;
//     return (
//         <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
//             <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
//                 <circle cx={c} cy={c} r={r} fill="none" stroke="#f1f3f5" strokeWidth={stroke} />
//                 <circle
//                     cx={c} cy={c} r={r} fill="none" stroke={color} strokeWidth={stroke}
//                     strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round"
//                     transform={`rotate(-90 ${c} ${c})`}
//                     style={{ transition: 'stroke-dashoffset 0.4s ease' }}
//                 />
//             </svg>
//             <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 17, fontWeight: 800, color: '#111827' }}>
//                 {Math.round(clamped)}%
//             </div>
//         </div>
//     );
// };

// /* ─── Small static pie chart showing the real composition of a metric
//        (e.g. Net Sales / Discount / Complimentary, or Early / On Time / Delayed / ...)
//        Pure SVG, built from actual values rather than a single synthetic % ─── */
// const HealthPieChart = ({ slices, size = 92 }) => {
//     const data = (slices || []).filter(s => Number(s.value) > 0);
//     const total = data.reduce((s, d) => s + Number(d.value), 0);
//     const c = size / 2;
//     const r = c;

//     if (!total) {
//         return (
//             <div style={{ width: size, height: size, borderRadius: '50%', background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
//                 <span style={{ fontSize: 9, color: '#d1d5db', fontWeight: 700 }}>No data</span>
//             </div>
//         );
//     }

//     // Single-slice case: full circle, no arc math needed (and avoids degenerate path)
//     if (data.length === 1) {
//         return (
//             <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
//                 <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
//                     <circle cx={c} cy={c} r={r} fill={data[0].color} />
//                 </svg>
//             </div>
//         );
//     }

//     let cumulative = 0;
//     const paths = data.map((d) => {
//         const startAngle = (cumulative / total) * 2 * Math.PI - Math.PI / 2;
//         cumulative += Number(d.value);
//         const endAngle = (cumulative / total) * 2 * Math.PI - Math.PI / 2;
//         const x1 = c + r * Math.cos(startAngle);
//         const y1 = c + r * Math.sin(startAngle);
//         const x2 = c + r * Math.cos(endAngle);
//         const y2 = c + r * Math.sin(endAngle);
//         const largeArc = endAngle - startAngle > Math.PI ? 1 : 0;
//         const path = `M ${c} ${c} L ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2} Z`;
//         return { path, color: d.color, key: d.label };
//     });

//     return (
//         <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
//             <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
//                 {paths.map(p => (
//                     <path key={p.key} d={p.path} fill={p.color} stroke="#fff" strokeWidth={1.5} />
//                 ))}
//             </svg>
//         </div>
//     );
// };

// /* ─── Revenue / Order health score cards ─── */
// const HealthScoreCard = ({ label, accent, slices, rows, banner }) => (
//     <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', padding: 14 }}>
//         <div style={{ fontSize: 10, fontWeight: 800, color: accent, textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: 10 }}>{label}</div>
//         <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
//             <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, flexShrink: 0 }}>
//                 <HealthPieChart slices={slices} />
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
//                     {(slices || []).filter(s => Number(s.value) > 0).map(s => (
//                         <div key={s.label} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 9.5 }}>
//                             <span style={{ width: 7, height: 7, borderRadius: 2, background: s.color, display: 'inline-block', flexShrink: 0 }} />
//                             <span style={{ color: '#9ca3af', fontWeight: 600 }}>{s.label}</span>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//             <div style={{ flex: 1, minWidth: 0 }}>
//                 {rows.map((r, i) => (
//                     <div
//                         key={i}
//                         onClick={r.onClick}
//                         style={{
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                             alignItems: 'baseline',
//                             marginBottom: i === 0 ? 4 : 2,
//                             cursor: r.onClick ? 'pointer' : 'default',
//                             padding: r.onClick ? '2px 5px' : '2px 0',
//                             borderRadius: r.onClick ? 6 : 0,
//                             transition: 'background 0.12s',
//                         }}
//                         onMouseEnter={e => { if (r.onClick) e.currentTarget.style.background = '#f3f4f6'; }}
//                         onMouseLeave={e => { if (r.onClick) e.currentTarget.style.background = ''; }}
//                         title={r.onClick ? `Click to view ${r.label}` : undefined}
//                     >
//                         <span style={{ fontSize: i === 0 ? 11 : 10.5, color: r.muted ? '#9ca3af' : '#6b7280', display: 'flex', alignItems: 'center', gap: 4 }}>
//                             {r.label}
//                             {r.onClick && <i className="bi bi-box-arrow-up-right" style={{ fontSize: 8, color: '#9ca3af' }} />}
//                         </span>
//                         <span style={{ fontSize: i === 0 ? 16 : 11, fontWeight: i === 0 ? 800 : 600, color: r.color || '#111827' }}>{r.value}</span>
//                     </div>
//                 ))}
//             </div>
//         </div>
//         {banner && (
//             <div style={{ marginTop: 10, background: banner.bg, color: banner.color, fontSize: 11, fontWeight: 700, padding: '7px 10px', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
//                 <i className={`bi ${banner.icon}`} style={{ fontSize: 11 }} />{banner.text}
//             </div>
//         )}
//     </div>
// ); 

// /* ─── Operations health card — raw counts + severity colour, no synthetic % ───
//    Each row is clickable and scrolls down to + highlights the matching
//    Operational Alerts card below (Stock Out → Stock Out Alert, Outlet Closures →
//    Outlet Closures, Damaged Products / Raw Material Damage → Damage Summary). ─── */
// const OpsStatusRow = ({ icon, label, count, color, onClick }) => (
//     <div
//         onClick={onClick}
//         style={{
//             display: 'flex', justifyContent: 'space-between', alignItems: 'center',
//             padding: '6px 4px', borderBottom: '1px solid #f9fafb',
//             cursor: onClick ? 'pointer' : 'default',
//             borderRadius: onClick ? 6 : 0,
//             transition: 'background 0.12s',
//         }}
//         onMouseEnter={e => { if (onClick) e.currentTarget.style.background = '#f3f4f6'; }}
//         onMouseLeave={e => { if (onClick) e.currentTarget.style.background = ''; }}
//         title={onClick ? `Click to view ${label}` : undefined}
//     >
//         <span style={{ fontSize: 11.5, color: '#374151', display: 'flex', alignItems: 'center', gap: 7 }}>
//             <i className={`bi ${icon}`} style={{ fontSize: 12, color }} />{label}
//             {onClick && <i className="bi bi-box-arrow-up-right" style={{ fontSize: 8, color: '#9ca3af' }} />}
//         </span>
//         <span style={{ fontSize: 13, fontWeight: 800, color: count > 0 ? color : '#9ca3af' }}>{fmtNum(count)}</span>
//     </div>
// );

// const OpsHealthCard = ({ stockOuts, closures, damagedProducts, damagedRawMaterial, banner, onNavigate }) => {
//     const allClear = stockOuts === 0 && closures === 0 && damagedProducts === 0 && damagedRawMaterial === 0;
//     return (
//         <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', padding: 14 }}>
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
//                 <div style={{ fontSize: 10, fontWeight: 800, color: '#d97706', textTransform: 'uppercase', letterSpacing: '0.6px' }}>Operations Health</div>
//                 {allClear && !banner && (
//                     <span style={{ fontSize: 9.5, fontWeight: 700, color: '#16a34a', display: 'flex', alignItems: 'center', gap: 4 }}>
//                         <i className="bi bi-check-circle-fill" style={{ fontSize: 10 }} />All Clear
//                     </span>
//                 )}
//             </div>
//             <OpsStatusRow icon="bi-exclamation-triangle-fill" label="Stock Outs" count={stockOuts} color="#dc2626" onClick={() => onNavigate?.('stockOut')} />
//             <OpsStatusRow icon="bi-door-closed-fill" label="Outlet Closures" count={closures} color="#d97706" onClick={() => onNavigate?.('closures')} />
//             <OpsStatusRow icon="bi-box-seam" label="Damaged Products" count={damagedProducts} color="#dc2626" onClick={() => onNavigate?.('damage')} />
//             <OpsStatusRow icon="bi-boxes" label="Raw Material Damage" count={damagedRawMaterial} color="#dc2626" onClick={() => onNavigate?.('damage')} />
//             {banner && (
//                 <div style={{ marginTop: 10, background: banner.bg, color: banner.color, fontSize: 11, fontWeight: 700, padding: '7px 10px', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
//                     <i className={`bi ${banner.icon}`} style={{ fontSize: 11 }} />{banner.text}
//                 </div>
//             )}
//         </div>
//     );
// };

// /* ─── Sales & Orders combo chart (bar = net sales, line = order count) ─── */
// const HourlyComboChart = ({ hourlyDistribution }) => {
//     const labels = (hourlyDistribution || []).map(h => h.timeSlot);
//     const sales = (hourlyDistribution || []).map(h => Number(h.netSales) || 0);
//     const orders = (hourlyDistribution || []).map(h => Number(h.totalOrders) || 0);

//     const chartData = {
//         labels,
//         datasets: [
//             {
//                 type: 'bar',
//                 label: 'Net Sales (₹)',
//                 data: sales,
//                 backgroundColor: '#85b7eb',
//                 borderRadius: 4,
//                 order: 2,
//                 yAxisID: 'y',
//             },
//             {
//                 type: 'line',
//                 label: 'Orders',
//                 data: orders,
//                 borderColor: '#6366f1',
//                 backgroundColor: '#6366f1',
//                 tension: 0.3,
//                 pointRadius: 4,
//                 pointBackgroundColor: '#6366f1',
//                 order: 1,
//                 yAxisID: 'y1',
//             },
//         ],
//     };

//     const options = {
//         responsive: true,
//         maintainAspectRatio: false,
//         interaction: { mode: 'index', intersect: false },
//         plugins: {
//             legend: { display: false },
//             tooltip: {
//                 callbacks: {
//                     label: (ctx) => ctx.dataset.label === 'Orders'
//                         ? `Orders: ${ctx.parsed.y}`
//                         : `Net Sales: ${fmt(ctx.parsed.y)}`,
//                 },
//             },
//         },
//         scales: {
//             x: { grid: { display: false }, ticks: { font: { size: 10 }, color: '#6b7280' } },
//             y: {
//                 position: 'left',
//                 grid: { color: '#f3f4f6' },
//                 ticks: { font: { size: 10 }, color: '#6b7280', callback: (v) => `₹${v}` },
//             },
//             y1: {
//                 position: 'right',
//                 grid: { drawOnChartArea: false },
//                 ticks: { font: { size: 10 }, color: '#6b7280', precision: 0 },
//             },
//         },
//     };

//     if (!labels.length) {
//         return <div style={{ textAlign: 'center', padding: '40px 0', color: '#d1d5db', fontSize: 12 }}>No hourly data</div>;
//     }

//     return (
//         <>
//             <div style={{ display: 'flex', gap: 16, marginBottom: 8, fontSize: 11 }}>
//                 <span style={{ display: 'flex', alignItems: 'center', gap: 5, color: '#6b7280' }}>
//                     <span style={{ width: 9, height: 9, borderRadius: 2, background: '#85b7eb', display: 'inline-block' }} />Net Sales
//                 </span>
//                 <span style={{ display: 'flex', alignItems: 'center', gap: 5, color: '#6b7280' }}>
//                     <span style={{ width: 9, height: 9, borderRadius: 2, background: '#6366f1', display: 'inline-block' }} />Orders
//                 </span>
//             </div>
//             <div style={{ position: 'relative', width: '100%', height: 230 }}>
//                 <Chart type="bar" data={chartData} options={options} />
//             </div>
//         </>
//     );
// };

// /* ─── Sales by channel donut (App / Swiggy / Zomato / Kiosk) ─── */
// const ChannelDonut = ({ channels }) => {
//     const filtered = channels.filter(c => c.value > 0);
//     if (!filtered.length) {
//         return <div style={{ textAlign: 'center', padding: '40px 0', color: '#d1d5db', fontSize: 12 }}>No channel data</div>;
//     }
//     const total = filtered.reduce((s, c) => s + c.value, 0);

//     const chartData = {
//         labels: filtered.map(c => c.label),
//         datasets: [{
//             data: filtered.map(c => c.value),
//             backgroundColor: filtered.map(c => c.color),
//             borderWidth: 0,
//         }],
//     };
//     const options = {
//         responsive: true,
//         maintainAspectRatio: false,
//         cutout: '68%',
//         plugins: {
//             legend: { display: false },
//             tooltip: { callbacks: { label: (ctx) => `${ctx.label}: ${fmt(ctx.parsed)}` } },
//         },
//     };

//     return (
//         <>
//             <div style={{ position: 'relative', width: '100%', height: 150 }}>
//                 <Doughnut data={chartData} options={options} />
//                 <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
//                     <div style={{ fontSize: 9, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase' }}>Total</div>
//                     <div style={{ fontSize: 15, fontWeight: 800, color: '#111827' }}>{fmt(total)}</div>
//                 </div>
//             </div>
//             <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 10 }}>
//                 {filtered.map(c => (
//                     <div key={c.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 11 }}>
//                         <span style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#374151' }}>
//                             <span style={{ width: 8, height: 8, borderRadius: 2, background: c.color, display: 'inline-block' }} />{c.label}
//                         </span>
//                         <span style={{ fontWeight: 700, color: '#111827' }}>{fmt(c.value)}</span>
//                     </div>
//                 ))}
//             </div>
//         </>
//     );
// };

// /* ─── Status badge colour helper ─── */
// const getStatusBadge = (status) => {
//     const map = {
//         COMPLETED: 'success',
//         DELIVERED: 'primary',
//         CONFIRMED: 'secondary',
//         'READY-TO-PICK': 'warning',
//         CANCELLED: 'danger',
//     };
//     return map[status] || 'dark';
// };

// /* ─── Orders Modal ─── */
// const OrdersModal = ({ show, onHide, modalType, outletId, dateFilter, appliedCustomRange, outletName }) => {
//     const token = localStorage.getItem('authToken');
//     const config = MODAL_CONFIGS[modalType] || MODAL_CONFIGS.total;

//     const [orders, setOrders] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const [totalCount, setTotalCount] = useState(0);
//     const LIMIT = 25;

//     const fetchOrders = useCallback(async (page = 1) => {
//         if (!outletId) return;
//         try {
//             setLoading(true);
//             const { startDate, endDate } = resolveDateRange(dateFilter, appliedCustomRange);
//             const params = { startDate, endDate, page: String(page), limit: String(LIMIT) };
//             if (config.statusFilter) params.orderStatus = config.statusFilter;
//             if (config.typeFilter) params.orderType = config.typeFilter;

//             const res = await axios({
//                 method: 'POST',
//                 url: 'order/getOrdersForAdmin/new',
//                 params,
//                 data: { outletIds: [outletId] },
//                 headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
//             });

//             const d = res?.data?.data;
//             if (d?.title === 'Success') {
//                 let fetched = d.orders || [];

//                 if (modalType === 'delayed') {
//                     fetched = fetched.filter(o => o.orderArrivalStatus === 'DELAYED');
//                 }
//                 if (modalType === 'early') {
//                     fetched = fetched.filter(o => o.orderArrivalStatus === 'EARLY');
//                 }

//                 const sorted = [...fetched].sort(
//                     (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
//                 );
//                 setOrders(sorted);
//                 setTotalPages(d.paginationData?.totalPages || 1);
//                 setTotalCount(d.paginationData?.totalRecords || fetched.length);
//                 setCurrentPage(d.paginationData?.currentPage || page);
//             } else {
//                 setOrders([]);
//             }
//         } catch (err) {
//             console.error('Orders modal fetch error:', err);
//             setOrders([]);
//         } finally {
//             setLoading(false);
//         }
//     }, [outletId, dateFilter, appliedCustomRange, modalType, config, token]);

//     useEffect(() => {
//         if (show) {
//             setCurrentPage(1);
//             fetchOrders(1);
//         } else {
//             setOrders([]);
//         }
//     }, [show, fetchOrders]);

//     const handlePageChange = (page) => {
//         if (page < 1 || page > totalPages) return;
//         setCurrentPage(page);
//         fetchOrders(page);
//     };

//     const { startDate, endDate } = resolveDateRange(dateFilter, appliedCustomRange);
//     const dateLabel = startDate === endDate ? startDate : `${startDate} → ${endDate}`;

//     const renderPages = () => {
//         if (totalPages <= 1) return null;
//         const items = [];
//         const max = Math.min(totalPages, 7);
//         let start = Math.max(1, currentPage - 3);
//         let end = Math.min(totalPages, start + max - 1);
//         if (end - start < max - 1) start = Math.max(1, end - max + 1);

//         if (start > 1) {
//             items.push(<Pagination.Item key={1} onClick={() => handlePageChange(1)}>1</Pagination.Item>);
//             if (start > 2) items.push(<Pagination.Ellipsis key="e1" />);
//         }
//         for (let i = start; i <= end; i++) {
//             items.push(
//                 <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>{i}</Pagination.Item>
//             );
//         }
//         if (end < totalPages) {
//             if (end < totalPages - 1) items.push(<Pagination.Ellipsis key="e2" />);
//             items.push(<Pagination.Item key={totalPages} onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>);
//         }
//         return items;
//     };

//     return (
//         <Modal show={show} onHide={onHide} size="xl" centered scrollable>
//             <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb', padding: '14px 20px' }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
//                     <div style={{
//                         width: 36, height: 36, borderRadius: 9,
//                         background: config.badge === 'danger' ? '#fee2e2' : config.badge === 'warning' ? '#fef3c7' : config.badge === 'success' ? '#dcfce7' : config.badge === 'primary' ? '#eff6ff' : '#f3f4f6',
//                         display: 'flex', alignItems: 'center', justifyContent: 'center',
//                     }}>
//                         <i className={
//                             config.badge === 'danger' ? 'bi bi-x-circle-fill' :
//                                 config.badge === 'warning' ? 'bi bi-clock-history' :
//                                     config.badge === 'success' ? 'bi bi-lightning-charge-fill' :
//                                         config.badge === 'secondary' ? 'bi bi-gift-fill' :
//                                             'bi bi-bag-fill'
//                         } style={{
//                             color: config.badge === 'danger' ? '#dc2626' : config.badge === 'warning' ? '#d97706' : config.badge === 'success' ? '#16a34a' : config.badge === 'primary' ? '#2563eb' : '#6b7280',
//                             fontSize: 16,
//                         }} />
//                     </div>
//                     <div>
//                         <div style={{ fontSize: 16, fontWeight: 800, color: '#111827' }}>{config.title}</div>
//                         <div style={{ fontSize: 11, color: '#6b7280', marginTop: 1 }}>
//                             <i className="bi bi-shop" style={{ fontSize: 10, marginRight: 4 }} />{outletName}
//                             <span style={{ margin: '0 6px', color: '#d1d5db' }}>·</span>
//                             <i className="bi bi-calendar3" style={{ fontSize: 10, marginRight: 4 }} />{dateLabel}
//                             {totalCount > 0 && (
//                                 <>
//                                     <span style={{ margin: '0 6px', color: '#d1d5db' }}>·</span>
//                                     <strong style={{ color: '#374151' }}>{fmtNum(totalCount)}</strong> records
//                                 </>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </Modal.Header>

//             <Modal.Body style={{ padding: 0 }}>
//                 {loading ? (
//                     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 0', gap: 12 }}>
//                         <Spinner animation="border" variant="primary" />
//                         <span style={{ fontSize: 13, color: '#6b7280' }}>Loading orders…</span>
//                     </div>
//                 ) : orders.length === 0 ? (
//                     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 0', gap: 10 }}>
//                         <i className="bi bi-inbox" style={{ fontSize: 40, color: '#d1d5db' }} />
//                         <div style={{ fontSize: 14, fontWeight: 700, color: '#374151' }}>No orders found</div>
//                         <div style={{ fontSize: 12, color: '#9ca3af' }}>Try adjusting the date range</div>
//                     </div>
//                 ) : (
//                     <div style={{ overflowX: 'auto' }}>
//                         <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
//                             <thead>
//                                 <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e5e7eb' }}>
//                                     {['Sr No', 'Date / Time', 'Order No', 'Customer', 'Status', 'Taxable', 'Tax', 'Discount', 'Total'].map((h, i) => (
//                                         <th key={h} style={{
//                                             padding: '10px 14px',
//                                             fontSize: 10, fontWeight: 700, color: '#6b7280',
//                                             textTransform: 'uppercase', letterSpacing: '0.6px',
//                                             whiteSpace: 'nowrap',
//                                             textAlign: i >= 7 ? 'right' : 'left',
//                                         }}>{h}</th>
//                                     ))}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {orders?.map((order, idx) => {
//                                     const name = order.user?.name || order.outletUser?.name || order.kioskUser?.name || 'N/A';
//                                     const mobile = order.user?.mobile || order.outletUser?.mobile || order.kioskUser?.mobile || '';
//                                     const orderNo = `${order?.order_sequence || ''}${order.order_no || ''}`;

//                                     return (
//                                         <tr key={order._id || idx} style={{ borderBottom: '1px solid #f0f2f5', transition: 'background 0.1s' }}
//                                             onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
//                                             onMouseLeave={e => e.currentTarget.style.background = ''}
//                                         >
//                                             <td style={{ padding: '10px 14px', color: '#9ca3af', fontSize: 12 }}>
//                                                 {(currentPage - 1) * LIMIT + idx + 1}
//                                             </td>
//                                             <td style={{ padding: '10px 14px', whiteSpace: 'nowrap' }}>
//                                                 <div style={{ fontSize: 12.5, fontWeight: 500, color: '#1a202c' }}>{fmtViewDate(order.createdAt)}</div>
//                                                 <div style={{ fontSize: 11, color: '#9ca3af' }}>{fmtViewTime(order.createdAt)}</div>
//                                             </td>
//                                             <td style={{ padding: '10px 14px' }}>
//                                                 <span style={{ fontSize: 12, fontWeight: 500, color: '#1a202c', background: '#f0f2f5', padding: '2px 7px', borderRadius: 4, whiteSpace: 'nowrap' }}>
//                                                     {orderNo}
//                                                 </span>
//                                             </td>
//                                             <td style={{ padding: '10px 14px', minWidth: 140 }}>
//                                                 <div style={{ fontWeight: 600, fontSize: 13, color: '#1a202c' }}>{name}</div>
//                                                 {mobile && <div style={{ fontSize: 11, color: '#2563eb' }}>{mobile}</div>}
//                                                 {order.kioskUser && (
//                                                     <span style={pillStyle('#eff6ff', '#1d4ed8')}>Kiosk</span>
//                                                 )}
//                                                 {order.subscriptionId && (
//                                                     <span style={pillStyle('#f0fdf4', '#15803d')}>Subscription</span>
//                                                 )}
//                                                 {(order.paymentMode === 'COMPLIMENTARY' || order.grandTotal === 0) && !order.subscriptionId && (
//                                                     <span style={pillStyle('#fdf4ff', '#7e22ce')}>Complimentary</span>
//                                                 )}
//                                                 {order?.outletUser && order.source === 'POS' && order.paymentMode !== 'COMPLIMENTARY' && !order.subscriptionId && (
//                                                     <span style={pillStyle('#fdf4ff', '#ce2295')}>POS</span>
//                                                 )}
//                                             </td>
//                                             <td style={{ padding: '10px 14px' }}>
//                                                 <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
//                                                     <Badge bg={getStatusBadge(order.orderStatus)} style={{ fontSize: 10, fontWeight: 700 }}>
//                                                         {order.orderStatus}
//                                                     </Badge>
//                                                     {order.orderArrivalStatus === 'DELAYED' && (
//                                                         <span style={{ ...arrivalStyle('#fef2f2', '#dc2626'), fontSize: 10 }}>
//                                                             ⏱ +{order.delayedArrival}m late
//                                                         </span>
//                                                     )}
//                                                     {order.orderArrivalStatus === 'EARLY' && (
//                                                         <span style={{ ...arrivalStyle('#f0fdf4', '#16a34a'), fontSize: 10 }}>
//                                                             ⚡ -{order.earlyArrival}m early
//                                                         </span>
//                                                     )}
//                                                 </div>
//                                             </td>
//                                             <td style={{ padding: '10px 14px', textAlign: 'right', whiteSpace: 'nowrap' }}>
//                                                 <span style={{ fontSize: 12.5, fontWeight: 500, color: '#059669' }}>₹{order.totalTaxable?.toFixed(2)}</span>
//                                             </td>
//                                             <td style={{ padding: '10px 14px', textAlign: 'right', whiteSpace: 'nowrap' }}>
//                                                 <span style={{ fontSize: 12.5, fontWeight: 500, color: '#d97706' }}>₹{order.totalTaxAmount?.toFixed(2)}</span>
//                                             </td>
//                                             <td style={{ padding: '10px 14px', textAlign: 'right', whiteSpace: 'nowrap' }}>
//                                                 <span style={{ fontSize: 12.5, fontWeight: 500, color: '#dc2626' }}>₹{order.totalDiscount?.toFixed(2)}</span>
//                                             </td>
//                                             <td style={{ padding: '10px 14px', textAlign: 'right', whiteSpace: 'nowrap' }}>
//                                                 <span style={{ fontSize: 13, fontWeight: 700, color: '#2563eb' }}>₹{order.grandTotal?.toFixed(2)}</span>
//                                             </td>
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}
//             </Modal.Body>

//             {!loading && totalPages > 1 && (
//                 <Modal.Footer style={{ borderTop: '1px solid #e5e7eb', padding: '10px 20px', justifyContent: 'space-between' }}>
//                     <span style={{ fontSize: 12, color: '#6b7280' }}>
//                         Page {currentPage} of {totalPages} · {fmtNum(totalCount)} total orders
//                     </span>
//                     <Pagination className="mb-0" size="sm">
//                         <Pagination.Prev disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)} />
//                         {renderPages()}
//                         <Pagination.Next disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)} />
//                     </Pagination>
//                 </Modal.Footer>
//             )}
//         </Modal>
//     );
// };

// /* ─── Tiny style helpers ─── */
// const pillStyle = (bg, color) => ({
//     display: 'inline-flex', alignItems: 'center', gap: 4,
//     padding: '2px 7px', borderRadius: 20,
//     fontSize: 10, fontWeight: 700,
//     background: bg, color, marginTop: 3,
//     border: `1px solid ${color}22`,
// });
// const arrivalStyle = (bg, color) => ({
//     display: 'inline-flex', alignItems: 'center',
//     padding: '2px 6px', borderRadius: 12,
//     fontWeight: 700,
//     background: bg, color,
// });

// /* ─── Bottom summary card ───
//    Accepts an optional `id` (for scroll targeting) and `highlighted` flag
//    (briefly pulses a ring/glow when navigated to from Operations Health). ─── */
// const BottomStatCard = ({ id, icon, title, accent, value, valueLabel, rows, ringPct, severity, products, highlighted }) => {
//     const [hover, setHover] = useState(false);
//     const sevColors = {
//         danger: { text: '#dc2626', bg: '#fee2e2', tag: 'High Priority' },
//         warning: { text: '#d97706', bg: '#fef3c7', tag: 'Attention' },
//         ok: { text: '#16a34a', bg: '#dcfce7', tag: null },
//     };
//     const sc = sevColors[severity] || sevColors.ok;

//     return (
//         <div
//             id={id}
//             onMouseEnter={() => setHover(true)}
//             onMouseLeave={() => setHover(false)}
//             onClick={() => { if (products?.length > 0) setHover(h => !h); }}
//             style={{
//                 position: 'relative', background: '#fff', borderRadius: 12,
//                 border: highlighted ? `1px solid ${sc.text}` : '1px solid #e5e7eb',
//                 padding: 14, cursor: products?.length > 0 ? 'pointer' : 'default',
//                 boxShadow: highlighted ? `0 0 0 4px ${sc.bg}, 0 8px 20px rgba(0,0,0,0.08)` : 'none',
//                 transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
//             }}
//         >
//             <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10 }}>
//                 <i className={`bi ${icon}`} style={{ fontSize: 12, color: sc.text }} />
//                 <span style={{ fontSize: 10, fontWeight: 800, color: sc.text, textTransform: 'uppercase', letterSpacing: '0.6px' }}>{title}</span>
//             </div>
//             <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
//                 <div style={{ flex: 1, minWidth: 0 }}>
//                     <div style={{ fontSize: 26, fontWeight: 800, color: '#111827', lineHeight: 1 }}>{value}</div>
//                     {valueLabel && <div style={{ fontSize: 10, color: '#9ca3af', fontWeight: 700, textTransform: 'uppercase', marginTop: 3 }}>{valueLabel}</div>}
//                     {rows && rows.map((r, i) => (
//                         <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, marginTop: 6 }}>
//                             <span style={{ color: '#6b7280' }}>{r.label}</span>
//                             <span style={{ fontWeight: 700, color: r.color || '#111827' }}>{r.value}</span>
//                         </div>
//                     ))}
//                 </div>
//                 {typeof ringPct === 'number' && <DonutRing pct={ringPct} color={sc.text} size={58} stroke={7} />}
//             </div>
//             {sc.tag && (
//                 <div style={{ marginTop: 10, fontSize: 10, fontWeight: 700, color: sc.text, display: 'flex', alignItems: 'center', gap: 4 }}>
//                     <i className="bi bi-arrow-down-short" /> {sc.tag}
//                 </div>
//             )}
//             {hover && products?.length > 0 && (
//                 <div style={{
//                     position: 'absolute', bottom: '100%', left: '50%', transform: 'translateX(-50%)',
//                     marginBottom: 8, background: '#1f2937', color: '#f9fafb', borderRadius: 9,
//                     padding: '8px 4px', minWidth: 200, boxShadow: '0 8px 20px rgba(0,0,0,0.28)',
//                     zIndex: 999999, border: '1px solid rgba(255,255,255,0.08)',
//                 }}>
//                     {products.map((p, i) => (
//                         <div key={p.productId || i} style={{
//                             display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
//                             padding: '4px 10px', fontSize: 11.5, fontWeight: 500,
//                             borderBottom: i < products.length - 1 ? '1px solid rgba(255,255,255,0.07)' : 'none',
//                         }}>
//                             <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.productName}</span>
//                             <span style={{ fontSize: 10, fontWeight: 700, color: sc.text, background: 'rgba(255,255,255,0.1)', borderRadius: 99, padding: '1px 7px', flexShrink: 0 }}>
//                                 × {p.exhaustedCount ?? p.damagedCount}
//                             </span>
//                         </div>
//                     ))}
//                     <div style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', width: 0, height: 0, borderLeft: '6px solid transparent', borderRight: '6px solid transparent', borderTop: '6px solid #1f2937' }} />
//                 </div>
//             )}
//         </div>
//     );
// };

// /* ════════════════════════════════════════════
//    MAIN COMPONENT
// ════════════════════════════════════════════ */
// const OutletDetailScreen = () => {
//     const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
//     const [skin, setSkin] = useState(currentSkin);
//     const { outletId } = useParams();
//     const navigate = useNavigate();
//     const location = useLocation();
//     const token = localStorage.getItem('authToken');

//     const {
//         outletName = 'Outlet Details',
//         dateFilter: initialDateFilter = 'today',
//         customRange: initialCustomRange = null,
//     } = location.state || {};

//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     const [dateFilter, setDateFilter] = useState(initialDateFilter);
//     const [appliedCustomRange, setAppliedCustomRange] = useState(initialCustomRange);
//     const [customStartDate, setCustomStartDate] = useState(
//         initialCustomRange ? new Date(initialCustomRange.start) : getDefaultStartDate
//     );
//     const [customEndDate, setCustomEndDate] = useState(
//         initialCustomRange ? new Date(initialCustomRange.end) : () => new Date()
//     );
//     const [customDateError, setCustomDateError] = useState('');
//     const [showPdfTooltip, setShowPdfTooltip] = useState(false);

//     /* ── Orders modal state ── */
//     const [ordersModal, setOrdersModal] = useState({ show: false, type: null });
//     const openOrdersModal = (type) => setOrdersModal({ show: true, type });
//     const closeOrdersModal = () => setOrdersModal({ show: false, type: null });

//     /* ── Operational alert highlight state ──
//        Maps an Operations Health row click to the target card's DOM id,
//        scrolls it into view, and briefly highlights it. ── */
//     const [highlightedAlert, setHighlightedAlert] = useState(null);
//     const ALERT_CARD_IDS = {
//         stockOut: 'alert-card-stock-out',
//         closures: 'alert-card-closures',
//         damage: 'alert-card-damage',
//     };

//     const handleOpsNavigate = (key) => {
//         const targetId = ALERT_CARD_IDS[key];
//         if (!targetId) return;
//         const el = document.getElementById(targetId);
//         if (el) {
//             el.scrollIntoView({ behavior: 'smooth', block: 'center' });
//         }
//         setHighlightedAlert(key);
//         window.clearTimeout(handleOpsNavigate._t);
//         handleOpsNavigate._t = window.setTimeout(() => setHighlightedAlert(null), 2200);
//     };

//     const fetchDetails = useCallback(async () => {
//         try {
//             setLoading(true); setError(null);
//             let url = `/dashboard/getRevenueStatThroughSummaryByOutlet?outletId=${outletId}`;
//             url += dateFilter === 'custom' && appliedCustomRange
//                 ? `&filterType=custom&startDate=${appliedCustomRange.start}&endDate=${appliedCustomRange.end}`
//                 : `&filterType=${dateFilter}`;
//             const res = await axiosInstance.get(url, { headers: { Authorization: `Bearer ${token}` } });
//             setData(res?.data?.data || null);
//         } catch (err) {
//             console.error(err);
//             setError('Failed to load outlet details.');
//         } finally {
//             setLoading(false);
//         }
//     }, [outletId, dateFilter, appliedCustomRange, token]);

//     const formatMinutes = (mins = 0) => {
//         const hrs = Math.floor(mins / 60);
//         const rem = mins % 60;
//         if (hrs === 0) return `${rem} Min`;
//         if (rem === 0) return `${hrs} Hr`;
//         return `${hrs} Hr ${rem} Min`;
//     };

//     useEffect(() => { fetchDetails(); }, [fetchDetails]);

//     const handleDateFilterChange = (val) => {
//         setDateFilter(val);
//         setCustomDateError('');
//         if (val === 'custom') {
//             const start = getDefaultStartDate();
//             const end = new Date();
//             setCustomStartDate(start);
//             setCustomEndDate(end);
//             setAppliedCustomRange({
//                 start: start.toISOString().split('T')[0],
//                 end: end.toISOString().split('T')[0],
//             });
//         } else {
//             setAppliedCustomRange(null);
//             setCustomStartDate(null);
//             setCustomEndDate(null);
//         }
//     };

//     const handleApplyCustomRange = () => {
//         if (!customStartDate || !customEndDate) {
//             setCustomDateError('Please select both dates.');
//             return;
//         }
//         const diffDays = Math.ceil((customEndDate - customStartDate) / (1000 * 60 * 60 * 24));
//         if (diffDays > 92) {
//             setCustomDateError('Range cannot exceed 92 days.');
//             return;
//         }
//         setCustomDateError('');
//         setAppliedCustomRange({
//             start: customStartDate.toISOString().split('T')[0],
//             end: customEndDate.toISOString().split('T')[0],
//         });
//     };

//     useEffect(() => {
//         const s = document.createElement('style');
//         s.id = 'outlet-print-style';
//         s.innerHTML = `@media print { body > *:not(#outlet-detail-root) { display:none!important; } #outlet-detail-root { display:block!important; background:#fff!important; } .no-print { display:none!important; } @page { margin:15mm; } }`;
//         document.head.appendChild(s);
//         return () => document.getElementById('outlet-print-style')?.remove();
//     }, []);

//     const { stats, hourlyDistribution, topProducts, bottomProducts,
//         topCoupons, totalOnlineSales, outletShiftSummary,
//         pettyCashSummary, damagedProductsSummary, exhaustedStockSummary, userStatsSummary } = data || {};

//     const netOrders = (Number(stats?.totalOrders) || 0) - (Number(stats?.cancelledOrders) || 0);

//     /* ── Revenue Health ── */
//     const totalSalesNum = Number(stats?.totalSales) || 0;
//     const netSalesNum = Number(stats?.netSales) || 0;
//     const discountNum = Number(stats?.discountAmount) || Math.max(totalSalesNum - netSalesNum, 0);
//     const revenueHealthPct = totalSalesNum > 0 ? (netSalesNum / totalSalesNum) * 100 : 0;
//     const revenueBanner = revenueHealthPct >= 85
//         ? { bg: '#dcfce7', color: '#16a34a', icon: 'bi-graph-up-arrow', text: 'Good Revenue Performance' }
//         : revenueHealthPct >= 65
//             ? { bg: '#fef3c7', color: '#d97706', icon: 'bi-graph-up', text: 'Fair Revenue Performance' }
//             : { bg: '#fee2e2', color: '#dc2626', icon: 'bi-exclamation-triangle', text: 'Needs Attention' };

//     /* ── Order Health ── */
//     const totalOrdersNum = Number(stats?.totalOrders) || 0;
//     const earlyNum = Number(stats?.earlyOrders) || 0;
//     const delayedNum = Number(stats?.delayedOrders) || 0;
//     const cancelledNum = Number(stats?.cancelledOrders) || 0;
//     const complimentaryNum = Number(stats?.complimentaryOrders) || 0;
//     const onTimeNum = Math.max(totalOrdersNum - earlyNum - delayedNum - cancelledNum - complimentaryNum, 0);
//     const orderHealthPct = totalOrdersNum > 0 ? ((earlyNum + onTimeNum) / totalOrdersNum) * 100 : 0;
//     const pct1 = (n) => totalOrdersNum > 0 ? `${Math.round((n / totalOrdersNum) * 100)}%` : '0%';
//     const orderBanner = orderHealthPct >= 80
//         ? { bg: '#dcfce7', color: '#16a34a', icon: 'bi-graph-up-arrow', text: 'Good Order Performance' }
//         : orderHealthPct >= 55
//             ? { bg: '#fef3c7', color: '#d97706', icon: 'bi-graph-up', text: 'Fair Order Performance' }
//             : { bg: '#fee2e2', color: '#dc2626', icon: 'bi-exclamation-triangle', text: 'Needs Attention' };

//     /* ── Operations Health ── */
//     const stockOutsNum = Number(exhaustedStockSummary?.totalExhaustedEntries) || 0;
//     const closuresNum = Number(outletShiftSummary?.outletClosedTotalTimes) || 0;
//     const damagedProductsNum = Number(damagedProductsSummary?.totalDamagedProducts) || 0;
//     const damagedRawMaterialNum = Number(data?.rawMaterialSummary?.totalTransactions) || 0;
//     const opsIssueCount = (stockOutsNum > 0 ? 1 : 0) + (closuresNum > 0 ? 1 : 0) + (damagedProductsNum > 0 ? 1 : 0) + (damagedRawMaterialNum > 0 ? 1 : 0);
//     const opsBanner = opsIssueCount === 0
//         ? { bg: '#dcfce7', color: '#16a34a', icon: 'bi-check-circle', text: 'All Clear' }
//         : opsIssueCount <= 1
//             ? { bg: '#fef3c7', color: '#d97706', icon: 'bi-exclamation-triangle', text: 'Minor Issues' }
//             : { bg: '#fee2e2', color: '#dc2626', icon: 'bi-exclamation-triangle-fill', text: 'Needs Attention' };

//     /* ── Sales by channel ──
//        NOTE: This total (App + Zomato + Swiggy + Kiosk) is intentionally a different
//        figure from stats.netSales shown in the Revenue Health card above. The channel
//        breakdown sums each platform's own revenue figure, which may be computed with
//        different tax/discount treatment than the aggregate netSales stat. Do not "fix"
//        these to match unless the backend confirms they should be identical. */
//     const channelData = [
//         { label: 'App', value: Number(stats?.appNetSale) || 0, color: '#378ADD' },
//         { label: 'Zomato', value: Number(totalOnlineSales?.zomato?.revenue) || 0, color: '#cf3a52' },
//         { label: 'Swiggy', value: Number(totalOnlineSales?.swiggy?.revenue) || 0, color: '#D85A30' },
//         { label: 'Kiosk', value: Number(stats?.kioskNetSale) || 0, color: '#1D9E75' },
//     ];

//     return (
//         <React.Fragment>
//             <Header onSkin={setSkin} />
//             <div id="outlet-detail-root" className="main main-app p-3 p-lg-4" style={{ background: '#f8fafc', minHeight: '100vh' }}>

//                 {/* Top Bar */}
//                 <div className="no-print" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14, flexWrap: 'wrap', gap: 10 }}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
//                         <button onClick={() => navigate(-1)}
//                             style={{ display: 'flex', alignItems: 'center', gap: 6, border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', padding: '7px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#374151' }}
//                             onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
//                             onMouseLeave={e => e.currentTarget.style.background = '#fff'}
//                         >
//                             <i className="bi bi-arrow-left" /> Back
//                         </button>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//                             <div style={{ width: 36, height: 36, borderRadius: 9, background: '#4d8af0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                                 <i className="bi bi-shop" style={{ fontSize: 16, color: '#fff' }} />
//                             </div>
//                             <div>
//                                 <div style={{ fontSize: 16, fontWeight: 800, color: '#111827' }}>{outletName}</div>
//                                 <div style={{ fontSize: 11, color: '#6b7280', display: 'flex', alignItems: 'center', gap: 4 }}>
//                                     <i className="bi bi-calendar3" style={{ fontSize: 10 }} /> {fmtDateLabel(dateFilter, appliedCustomRange)}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className='d-flex align-items-center gap-2'>
//                         <div className="d-flex align-items-center bg-light p-1 ps-2 rounded" style={{ flexWrap: 'wrap', gap: 8, border: '0.5px solid rgb(77, 138, 240)' }}>
//                             <i className="bi bi-calendar-event text-primary" style={{ fontSize: 12 }} />
//                             <Form.Select
//                                 value={dateFilter}
//                                 onChange={(e) => handleDateFilterChange(e.target.value)}
//                                 size="sm"
//                                 style={{ width: 145 }}
//                                 className="border-0 bg-light"
//                             >
//                                 {DATE_FILTER_OPTIONS.map((opt) => (
//                                     <option key={opt.value} value={opt.value}>{opt.label}</option>
//                                 ))}
//                             </Form.Select>
//                             {['last7days', 'last30days', 'thisMonth', 'lastMonth'].includes(dateFilter) && (
//                                 <span style={{ fontSize: 10, color: '#888', width: '100%', paddingLeft: 2 }}>
//                                     * Today's data not included
//                                 </span>
//                             )}

//                             {dateFilter === 'custom' && (
//                                 <div className="d-flex align-items-center gap-2">
//                                     <div className="d-flex flex-column">
//                                         <span style={{ fontSize: 10, color: '#3f3f3f', marginBottom: 2 }}>Start date</span>
//                                         <DatePicker
//                                             selected={customStartDate}
//                                             onChange={(date) => {
//                                                 setCustomStartDate(date);
//                                                 if (customEndDate) {
//                                                     const diff = Math.ceil((customEndDate - date) / (1000 * 60 * 60 * 24));
//                                                     if (diff > 92 || diff < 0) setCustomEndDate(null);
//                                                 }
//                                                 setCustomDateError('');
//                                             }}
//                                             selectsStart startDate={customStartDate} endDate={customEndDate}
//                                             minDate={new Date(new Date().setDate(new Date().getDate() - 92))}
//                                             maxDate={new Date()} dateFormat="dd-MM-yyyy" placeholderText="Start date"
//                                             className="form-control form-control-sm" wrapperClassName="date-picker-wrapper"
//                                         />
//                                     </div>
//                                     <span style={{ fontSize: 13, color: '#888', marginTop: 14 }}>→</span>
//                                     <div className="d-flex flex-column">
//                                         <span style={{ fontSize: 10, color: '#3f3f3f', marginBottom: 2 }}>End date</span>
//                                         <DatePicker
//                                             selected={customEndDate}
//                                             onChange={(date) => { setCustomEndDate(date); setCustomDateError(''); }}
//                                             selectsEnd startDate={customStartDate} endDate={customEndDate}
//                                             minDate={customStartDate || new Date(new Date().setDate(new Date().getDate() - 90))}
//                                             maxDate={customStartDate ? new Date(Math.min(new Date(customStartDate).setDate(customStartDate.getDate() + 92), new Date())) : new Date()}
//                                             disabled={!customStartDate} dateFormat="dd-MM-yyyy" placeholderText="End date"
//                                             className="form-control form-control-sm" wrapperClassName="date-picker-wrapper"
//                                         />
//                                     </div>
//                                     <div className="d-flex flex-column">
//                                         <span style={{ fontSize: 10, color: 'transparent', marginBottom: 2 }}>-</span>
//                                         <Button size="sm" variant="primary" onClick={handleApplyCustomRange} disabled={!customStartDate || !customEndDate}>
//                                             Apply
//                                         </Button>
//                                     </div>
//                                 </div>
//                             )}
//                             {dateFilter === 'custom' && customDateError && (
//                                 <span style={{ fontSize: 11, color: '#dc3545', width: '100%', paddingLeft: 2 }}>⚠ {customDateError}</span>
//                             )}
//                         </div>

//                         <div style={{ position: 'relative', display: 'inline-block' }}
//                             onMouseEnter={() => setShowPdfTooltip(true)}
//                             onMouseLeave={() => setShowPdfTooltip(false)}
//                         >
//                             <button
//                                 onClick={() => { }}
//                                 style={{ display: 'flex', alignItems: 'center', gap: 7, background: '#fff', color: '#9ca3af', border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 18px', cursor: 'not-allowed', fontSize: 13, fontWeight: 600 }}
//                             >
//                                 <i className="bi bi-file-earmark-pdf-fill" style={{ fontSize: 14 }} /> Download PDF
//                             </button>
//                             {showPdfTooltip && (
//                                 <div style={{
//                                     position: 'absolute', bottom: '100%', right: 0, marginBottom: 8,
//                                     background: '#1f2937', color: '#f9fafb', borderRadius: 8,
//                                     padding: '7px 12px', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap',
//                                     boxShadow: '0 8px 20px rgba(0,0,0,0.28)', zIndex: 999999,
//                                 }}>
//                                     In Development process, Will be Available soon
//                                     <div style={{ position: 'absolute', top: '100%', right: 14, width: 0, height: 0, borderLeft: '6px solid transparent', borderRight: '6px solid transparent', borderTop: '6px solid #1f2937' }} />
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>

//                 {loading && (
//                     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 340, gap: 12 }}>
//                         <Spinner animation="border" variant="primary" />
//                         <span style={{ fontSize: 13, color: '#6b7280' }}>Loading outlet details...</span>
//                     </div>
//                 )}
//                 {error && (
//                     <div style={{ textAlign: 'center', padding: '80px 0' }}>
//                         <i className="bi bi-exclamation-circle" style={{ fontSize: 36, color: '#ef4444', display: 'block', marginBottom: 10 }} />
//                         <div style={{ fontSize: 13, color: '#374151', marginBottom: 14 }}>{error}</div>
//                         <button onClick={fetchDetails} style={{ padding: '7px 18px', borderRadius: 8, border: 'none', background: '#4d8af0', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Retry</button>
//                     </div>
//                 )}

//                 {!loading && !error && data && (
//                     <>
//                         {/* ── Health Score Cards ── */}
//                         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,minmax(0,1fr))', gap: 8, marginBottom: 10 }}>
//                             <HealthScoreCard
//                                 label="Revenue Health"
//                                 accent="#16a34a"
//                                 slices={[
//                                     { label: 'Net Sales', value: netSalesNum, color: '#16a34a' },
//                                     { label: 'Discount Amount', value: discountNum, color: '#d97706' },
//                                     { label: 'Complimentary Amount', value: Number(stats?.complimentaryOrderAmount) || 0, color: '#8b5cf6' },
//                                 ]}
//                                 rows={[
//                                     { label: 'Net Sales', value: fmt(netSalesNum), color: '#16a34a' },
//                                     { label: 'Total Sales', value: fmt(totalSalesNum) },
//                                     { label: 'Discount Amount', value: fmt(discountNum), color: '#d97706' },
//                                     { label: 'Complimentary Amount', value: fmt(stats?.complimentaryOrderAmount), color: '#8b5cf6' },
//                                 ]}
//                                 // banner={revenueBanner}
//                             />
//                             <HealthScoreCard
//                                 label="Order Health"
//                                 accent="#0ea5e9"
//                                 slices={[
//                                     { label: 'Early Orders', value: earlyNum, color: '#16a34a' },
//                                     { label: 'On Time Orders', value: onTimeNum, color: '#0ea5e9' },
//                                     { label: 'Delayed Orders', value: delayedNum, color: '#d97706' },
//                                     { label: 'Cancelled Orders', value: cancelledNum, color: '#dc2626' },
//                                     { label: 'Complimentary Orders', value: complimentaryNum, color: '#8b5cf6' },
//                                 ]}
//                                 rows={[
//                                     { label: 'Total Orders', value: fmtNum(totalOrdersNum), onClick: () => openOrdersModal('total') },
//                                     { label: 'Net Orders', value: fmtNum(netOrders) },
//                                     { label: 'Early Orders', value: `${fmtNum(earlyNum)} (${pct1(earlyNum)})`, color: '#16a34a', onClick: () => openOrdersModal('early') },
//                                     { label: 'On Time Orders', value: `${fmtNum(onTimeNum)} (${pct1(onTimeNum)})`, color: '#0ea5e9' },
//                                     { label: 'Delayed Orders', value: `${fmtNum(delayedNum)} (${pct1(delayedNum)})`, color: '#d97706', onClick: () => openOrdersModal('delayed') },
//                                     { label: 'Cancelled Orders', value: `${fmtNum(cancelledNum)} (${pct1(cancelledNum)})`, color: '#dc2626', onClick: () => openOrdersModal('cancelled') },
//                                     { label: 'Complimentary Orders', value: `${fmtNum(complimentaryNum)} (${pct1(complimentaryNum)})`, color: '#8b5cf6', onClick: () => openOrdersModal('complimentary') },
//                                 ]}
//                                 // banner={orderBanner}
//                             />
//                             <OpsHealthCard
//                                 stockOuts={stockOutsNum}
//                                 closures={closuresNum}
//                                 damagedProducts={damagedProductsNum}
//                                 damagedRawMaterial={damagedRawMaterialNum}
//                                 onNavigate={handleOpsNavigate}
//                                 // banner={opsBanner}
//                             />
//                         </div>

//                         {/* ── Charts Row: Hourly combo chart + Sales by channel ── */}
//                         <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: 8, marginBottom: 10 }}>
//                             <Card title="Sales & Orders Through The Day" icon="bi-bar-chart-line-fill">
//                                 <HourlyComboChart hourlyDistribution={hourlyDistribution} />
//                             </Card>
//                             <Card title="Sales By Channel" icon="bi-pie-chart-fill">
//                                 <ChannelDonut channels={channelData} />
//                             </Card>
//                         </div>

//                         {/* Bento Grid */}
//                         <div className="bento-grid mt-3" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1.4fr', gap: 8, alignItems: 'start' }}>

//                             {/* Col A — compact "money movement" cards stacked together so there's no orphaned whitespace */}
//                             <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
//                                 <Card title="Online Platform Sales" icon="bi-globe2">
//                                     {[
//                                         {
//                                             label: 'Swiggy', color: '#ff6900', bg: '#fff4ed',
//                                             rev: totalOnlineSales?.swiggy?.revenue, orders: totalOnlineSales?.swiggy?.totalOrders,
//                                             logo: 'https://upload.wikimedia.org/wikipedia/commons/1/13/Swiggy_logo.png',
//                                         },
//                                         {
//                                             label: 'Zomato', color: '#e23744', bg: '#fff5f5',
//                                             rev: totalOnlineSales?.zomato?.revenue, orders: totalOnlineSales?.zomato?.totalOrders,
//                                             logo: 'https://upload.wikimedia.org/wikipedia/commons/7/75/Zomato_logo.png',
//                                         },
//                                     ].map(p => (
//                                         <div key={p.label} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 10px', borderRadius: 8, background: p.bg, marginBottom: 6 }}>
//                                             <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//                                                 <img
//                                                     src={p.logo}
//                                                     alt={`${p.label} logo`}
//                                                     style={{ width: 18, height: 18, objectFit: 'contain', borderRadius: 4, flexShrink: 0 }}
//                                                     onError={(e) => { e.currentTarget.style.display = 'none'; }}
//                                                 />
//                                                 <div>
//                                                     <div style={{ fontSize: 11, fontWeight: 700, color: '#374151' }}>{p.label}</div>
//                                                     <div style={{ fontSize: 10, color: '#9ca3af' }}>{fmtNum(p.orders)} orders</div>
//                                                 </div>
//                                             </div>
//                                             <div style={{ fontSize: 14, fontWeight: 800, color: '#111827' }}>{fmt(p.rev)}</div>
//                                         </div>
//                                     ))}
//                                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 4px', borderTop: '1px dashed #e5e7eb', marginTop: 2 }}>
//                                         <span style={{ fontSize: 10, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase' }}>Total</span>
//                                         <span style={{ fontSize: 14, fontWeight: 800, color: '#0ea5e9' }}>{fmt(totalOnlineSales?.totalRevenue)}</span>
//                                     </div>
//                                 </Card>
//                                 {topCoupons?.length > 0 && (
//                                     <Card title="Top Coupons Used" icon="bi-tag-fill">
//                                         {topCoupons.map((c) => (
//                                             <CouponRow key={c._id} coupon={c.couponCode} used={c.totalUsed} discount={c.totalDiscount} />
//                                         ))}
//                                     </Card>
//                                 )}
//                             </div>

//                             {/* Col B */}
//                             <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
//                                 <Card title="Top Performers" icon="bi-trophy-fill">
//                                     {(topProducts || []).length > 0
//                                         ? topProducts.map((p, i) => <RankRow key={p._id} rank={i + 1} name={p.productName} qty={p.totalQty} isTop={true} />)
//                                         : <div style={{ fontSize: 11, color: '#d1d5db', padding: '8px 0' }}>No data</div>
//                                     }
//                                 </Card>
//                             </div>

//                             {/* Col C */}
//                             <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
//                                 <Card title="Low Performers" icon="bi-arrow-down-circle-fill">
//                                     {(bottomProducts || []).length > 0
//                                         ? bottomProducts.map((p, i) => <RankRow key={p._id} rank={i + 1} name={p.productName} qty={p.totalQty} isTop={false} />)
//                                         : <div style={{ fontSize: 11, color: '#d1d5db', padding: '8px 0' }}>No data</div>
//                                     }
//                                 </Card>
//                             </div>
//                         </div>

//                         {/* ── Bottom Row ── */}
//                         <div style={{ fontSize: 10, fontWeight: 800, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.7px', margin: '18px 0 8px 2px' }}>
//                             Operational Alerts
//                         </div>
//                         <div className="mt-0" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,minmax(0,1fr))', gap: 8 }}>
//                             <BottomStatCard
//                                 id={ALERT_CARD_IDS.stockOut}
//                                 highlighted={highlightedAlert === 'stockOut'}
//                                 icon="bi-exclamation-triangle-fill"
//                                 title="Stock Out Alert"
//                                 value={fmtNum(exhaustedStockSummary?.totalExhaustedEntries)}
//                                 valueLabel="Products Exhausted"
//                                 ringPct={exhaustedStockSummary?.totalExhaustedEntries > 0 ? 100 : 0}
//                                 severity={exhaustedStockSummary?.totalExhaustedEntries > 0 ? 'danger' : 'ok'}
//                                 products={exhaustedStockSummary?.products}
//                             />
//                             <BottomStatCard
//                                 id={ALERT_CARD_IDS.closures}
//                                 highlighted={highlightedAlert === 'closures'}
//                                 icon="bi-door-closed-fill"
//                                 title="Outlet Closures"
//                                 value={fmtNum(outletShiftSummary?.outletClosedTotalTimes)}
//                                 valueLabel={outletShiftSummary?.outletClosedTotalTimes === 1 ? 'Closure Today' : 'Closures Today'}
//                                 rows={[{ label: 'Total Duration', value: formatMinutes(outletShiftSummary?.outletClosedTotalDurationInMinutes) }]}
//                                 severity={outletShiftSummary?.outletClosedTotalTimes > 0 ? 'warning' : 'ok'}
//                             />
//                             <BottomStatCard
//                                 id={ALERT_CARD_IDS.damage}
//                                 highlighted={highlightedAlert === 'damage'}
//                                 icon="bi-box-seam"
//                                 title="Damage Summary"
//                                 value={fmtNum(damagedProductsNum + damagedRawMaterialNum)}
//                                 valueLabel="Total Damaged (Products + Raw Materials)"
//                                 rows={[
//                                     { label: 'Damaged Products', value: fmtNum(damagedProductsNum) },
//                                     { label: 'Damaged Raw Materials', value: fmtNum(damagedRawMaterialNum) },
//                                 ]}
//                                 severity={(damagedProductsNum + damagedRawMaterialNum) > 0 ? 'danger' : 'ok'}
//                                 products={damagedProductsSummary?.products}
//                             />
//                             <BottomStatCard
//                                 icon="bi-cash-stack"
//                                 title="Petty Cash Summary"
//                                 value={fmt(pettyCashSummary?.totalCreditAmount)}
//                                 valueLabel={`${pettyCashSummary?.totalCreditAmount > 0 ? '1+' : '0'} Credit Transaction`}
//                                 rows={[
//                                     { label: 'Credit Amount', value: fmt(pettyCashSummary?.totalCreditAmount), color: '#16a34a' },
//                                     { label: 'Debit Amount', value: fmt(pettyCashSummary?.totalDebitAmount), color: '#dc2626' },
//                                     { label: 'Net Balance', value: fmt((Number(pettyCashSummary?.totalCreditAmount) || 0) - (Number(pettyCashSummary?.totalDebitAmount) || 0)) },
//                                 ]}
//                                 severity="ok"
//                             />
//                         </div>
//                     </>
//                 )}

//                 <style>{`
//                     @media (max-width: 960px) { .bento-grid { grid-template-columns: 1fr 1fr !important; } }
//                     @media (max-width: 620px) { .bento-grid { grid-template-columns: 1fr !important; } }
//                 `}</style>
//             </div>

//             <OrdersModal
//                 show={ordersModal.show}
//                 onHide={closeOrdersModal}
//                 modalType={ordersModal.type}
//                 outletId={outletId}
//                 dateFilter={dateFilter}
//                 appliedCustomRange={appliedCustomRange}
//                 outletName={outletName}
//             />
//         </React.Fragment>
//     );
// };

// export default OutletDetailScreen;